module.exports = __webpack_public_path__ + "static/media/fileld-like.c6d15a2d.svg";